export const DASHBOARD = 'Dashboard'
export const CITATIONS = 'Citations'
export const PAPERS = 'Papers'
export const GUIDES = 'Guides'
